import React,{useState,useEffect} from 'react';
import {Result} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function DependenciesComponent(props){

	const [authorized,setAuthorized] = useState(null);

	useEffect(()=>{
		var len = props.dependencies.length;
		var auth = true;
		for(var a=0;a<len;a++){
			var namespace = props.dependencies[a];
			if(undefined === props.endpoints[namespace]){
				auth = false;
			}
		}
		setAuthorized(auth);
	},[props.endpoints]);

	if(authorized === null)
	return (
		<div style={{width:"100%",color:"#CCC"}}>
			<FontAwesomeIcon className="fa-spin" icon="sync"/>
		</div>
	);
	if(authorized === false && props.mode === "hide")
	return (
		<></>
	);
	if(authorized === false && props.mode === "block")
	return (
		<>
			<Result
				status="403"
				title="Unauthorized"
				subTitle={"This component requires access to the following namespaces:"+props.dependencies.join()}
			/>
		</>
	);
	if(authorized === true)
	return (
		<>
			{props.children}
		</>
	);
}

export default DependenciesComponent;
